import React, { memo, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MaterialSlider from '@mui/material/Slider';
import { Colors } from 'modules/theme';
import { secondsToDuration } from '../../../audio/services/assets';
import classesFromFile from './Slider.module.scss';

const PREFIX = 'Slider';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')({
  [`& .${classes.root}`]: sliderStyle => ({
    color: Colors.grayishBlue,
    paddingTop: 11,
    paddingBottom: 11,
    ...sliderStyle,
  }),
});

function Slider({
  min,
  max,
  value,
  setValue,
  sliderStyle,
  containerClassName,
  durationLabelClassName,
}) {
  const containerClasses = classNames(
    classesFromFile.container,
    containerClassName,
  );

  const durationLabelClasses = classNames(
    classesFromFile.durationLabel,
    durationLabelClassName,
  );

  const [sliderValue, setSliderValue] = useState(0);
  const [isSeeking, setIsSeeking] = useState(false);

  useEffect(() => {
    if (!isSeeking) {
      setSliderValue(value);
    }
  }, [isSeeking, value]);

  function handleChange(event, newValue) {
    setIsSeeking(true);
    setSliderValue(newValue);
  }

  function handleChangeCommitted(event, newValue) {
    setIsSeeking(false);
    setValue(newValue);
  }

  return (
    <Root className={containerClasses}>
      <div className={durationLabelClasses}>{secondsToDuration(value)}</div>
      <MaterialSlider
        className={classes.root}
        min={min}
        max={max}
        value={sliderValue}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
        aria-labelledby="continuous-slider"
        component="div"
      />
      <div className={durationLabelClasses}>{secondsToDuration(max)}</div>
    </Root>
  );
}

Slider.defaultProps = {
  min: 0,
};

Slider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  setValue: PropTypes.func,
  sliderStyle: PropTypes.object,
  containerClassName: PropTypes.string,
  durationLabelClassName: PropTypes.string,
};

export default memo(Slider);
